export var MemberStatusEnum;
(function (MemberStatusEnum) {
    MemberStatusEnum["NEW"] = "new";
    MemberStatusEnum["ACTIVE"] = "active";
    MemberStatusEnum["INVITED"] = "invited";
})(MemberStatusEnum || (MemberStatusEnum = {}));
